import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { InteractionHistoryState } from "./useInteractionHistory";
import styles from "./Dashboard.module.scss";

type Props = {
  history?: InteractionHistoryState;
  onOpen: () => void;
  className: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
};

export default function QuickViewButton({ history, onOpen, className, style, children }: Props) {
  const checking = !history || history.status === "loading";
  const empty = history?.status === "empty";
  const disabled = checking || empty;
  const description = checking
    ? "Checking interaction history..."
    : empty
      ? "No interaction history"
      : history?.status === "error"
        ? "Unable to check interaction history. Click to retry."
        : "Quick view";

  return (
    <Tooltip title={description} describeChild>
      <span
        className={styles.quickViewAction}
        data-disabled={disabled}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className={className}
          style={style}
          disabled={disabled}
          aria-label={description === "Quick view" ? description : `Quick view: ${description}`}
          aria-busy={checking}
          onClick={(event) => {
            event.stopPropagation();
            onOpen();
          }}
        >
          {children}
        </button>
      </span>
    </Tooltip>
  );
}
